import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";

interface PageChangeWarningDialogProps {
  open: boolean;
  selectedCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

const PageChangeWarningDialog: React.FC<PageChangeWarningDialogProps> = ({ open, selectedCount, onCancel, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
  >
    <DialogTitle sx={{ fontWeight: 600, fontSize: 15, pb: 1 }}>
      Selection
    </DialogTitle>
    <DialogContent sx={{ pt: 0 }}>
      <Typography variant="body2" color="text.secondary">
        You have{" "}
        <Box component="span" sx={{ fontWeight: 700, color: "text.primary" }}>
          {selectedCount} item{selectedCount !== 1 ? "s" : ""}
        </Box>{" "}
        selected. Selections are page-specific and will be cleared when you
        navigate to another page. Do you want to continue?
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
      <Button
        variant="outlined"
        size="small"
        onClick={onCancel}
        sx={{
          borderRadius: 28,
          textTransform: "none",
          borderColor: "#000",
          color: "#000",
          "&:hover": { borderColor: "#333", backgroundColor: "rgba(0,0,0,0.04)" },
        }}
      >
        Stay
      </Button>
      <Button
        variant="contained"
        size="small"
        onClick={onConfirm}
        sx={{
          borderRadius: 28,
          textTransform: "none",
          backgroundColor: "#000",
          "&:hover": { backgroundColor: "#333" },
        }}
      >
        Continue
      </Button>
    </DialogActions>
  </Dialog>
);

export default PageChangeWarningDialog;
